var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicantWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Applicant"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Applicant",
    clipPath: "url(#clip-Applicant)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Applicant-2",
    "data-name": "Applicant",
    transform: "translate(-51.007 497.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17192",
    "data-name": "Path 17192",
    d: "M55.882-495.993a2.877,2.877,0,0,0-1.451.75,2.913,2.913,0,0,0-.861,1.432l-.082.3v5.733c0,6.505-.026,5.93.319,6.631a2.969,2.969,0,0,0,1.855,1.536,9.682,9.682,0,0,0,2.52.1l2.245.011.1-.4a4.33,4.33,0,0,1,1.2-2.108A4.574,4.574,0,0,1,63-482.92a.62.62,0,0,0,.193-.1,1.746,1.746,0,0,0-.219-.2,2.954,2.954,0,0,1-.917-1.436,2.808,2.808,0,0,1-.063-.779,1.947,1.947,0,0,1,.119-.891,2.944,2.944,0,0,1,2.067-1.933,3.268,3.268,0,0,1,1.444,0,3.163,3.163,0,0,1,1.043.5,1.179,1.179,0,0,0,.249.171c.022,0,.03-1.247.022-2.961a15.563,15.563,0,0,0-.1-3.255,2.978,2.978,0,0,0-.85-1.432A2.88,2.88,0,0,0,64.5-496C64.109-496.071,56.249-496.068,55.882-495.993Zm7.763,2.98a.639.639,0,0,1,.278.571.574.574,0,0,1-.286.427l-.122.085h-3.3c-3.292,0-3.3,0-3.44-.078a.6.6,0,0,1-.111-.943c.182-.167.174-.163,3.6-.156l3.247.007Zm-.2,3.091a.519.519,0,0,1,.315.182.554.554,0,0,1-.033.816l-.134.13-3.362.011-3.362.007-.122-.082a.589.589,0,0,1,.208-1.072C57.181-489.974,63.241-489.967,63.449-489.922Zm-3.392,3.154a.6.6,0,0,1,.427.735.657.657,0,0,1-.382.393c-.045.011-.8.015-1.677.011-1.529-.011-1.6-.015-1.7-.085a.6.6,0,0,1,.212-1.061C57.129-486.82,59.875-486.812,60.057-486.768Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17193",
    "data-name": "Path 17193",
    d: "M307.744-264.454A2.053,2.053,0,0,0,306-262.432a2.077,2.077,0,0,0,1.521,1.989,2.76,2.76,0,0,0,1.061-.011,2.073,2.073,0,0,0,1.5-1.978,2.052,2.052,0,0,0-1.484-1.959A2.182,2.182,0,0,0,307.744-264.454Z",
    transform: "translate(-243.141 -222.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17194",
    "data-name": "Path 17194",
    d: "M266.835-129.779a3.642,3.642,0,0,0-3.147,3.459c-.007.371.071.534.323.653.156.078.2.078,3.3.078,3.054,0,3.147,0,3.284-.074a.639.639,0,0,0,.319-.434,3.641,3.641,0,0,0-.156-1.143,3.636,3.636,0,0,0-3.054-2.542A2.988,2.988,0,0,0,266.835-129.779Z",
    transform: "translate(-202.399 -352.647)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicantWhite);
export default __webpack_public_path__ + "static/media/Applicant_White.63719a53fb858956cb9308a2e50c3d27.svg";
export { ForwardRef as ReactComponent };